/* eslint-disable filenames/match-exported */
/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel <manuel.garcia@ironbit.com.mx>, March 2020
 */
export * from './types';
export * from './config';
export * from './signals';
export * from './queue';
export * from './strings';
export * from './objects';
export * from './ponyfills';
export * from './reflection';
export * from './collections';



// WEBPACK FOOTER //
// ./src/packages/core/lib/index.ts